module.exports = __webpack_public_path__ + "static/media/4.527ca3bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/existLogos/4.jpg
// module id = 980
// module chunks = 4